import dayjs, { ManipulateType } from 'dayjs';

interface INotificationData {
    [key: string]: any | ITemporalNotification;
}

interface ITemporalNotification {
    start: string;
    duration: number;
    visited: false;
}

export interface IOnboardingDataPayload {
    [key: string]: boolean | ITemporalNotification;
}
export class OnboardingNotifications {
    static DAYS = 'days';
    static DEFAULT_DAYS_CONFIGURATION = 30;
    static HOME_DAYS_CONFIGURATION = 7;

    private _notifications: INotificationData;
    private _notificationStatusUpdated: boolean;
    private _updatedProperties: string[];
    public fetchingData: boolean;

    constructor(notifications: IOnboardingDataPayload | [] = []) {
        const isDataArray = notifications instanceof Array;
        this._notificationStatusUpdated = false;
        this._updatedProperties = [];

        if (!isDataArray) {
            this._notifications = { ...notifications };
        } else {
            this._notifications = {};
        }
    }

    get notificationUpdated() {
        return this._notificationStatusUpdated;
    }

    get values() {
        return this._notifications;
    }

    public mergeUpdatedNotifications(notifications: IOnboardingDataPayload): IOnboardingDataPayload {
        const isDataArray = notifications instanceof Array;
        const newNotifications = isDataArray ? {} : { ...notifications };

        this._updatedProperties.forEach(notificationType => {
            const newNotification = notifications[notificationType];
            const start = typeof newNotification !== 'boolean' && newNotification?.start;

            newNotifications[notificationType] = this._notifications[notificationType];

            if (start) {
                newNotifications[notificationType] = {
                    ...this._notifications[notificationType],
                    start,
                };
            }
        });

        return newNotifications;
    }

    public notificationStored() {
        this._notificationStatusUpdated = false;
        this._updatedProperties = [];
    }

    public isTemporalNotificationVisible(
        type: string,
        duration: number = OnboardingNotifications.DEFAULT_DAYS_CONFIGURATION
    ): boolean {
        let notification = this._notifications[type];

        if (!notification) {
            notification = this._createTemporalNotification(duration);

            this._notifications[type] = notification;
            this._notificationStatusUpdated = true;
            this._updatedProperties.push(type);
        }

        const notificationVisibleUntil = dayjs(notification.start).add(
            notification.duration,
            OnboardingNotifications.DAYS as ManipulateType
        );

        return !notification.visited && dayjs().isBefore(notificationVisibleUntil);
    }

    public visitSection(type: string): void {
        let notification = this._notifications[type];

        if (notification && typeof notification.visited !== 'undefined' && !notification.visited) {
            notification.visited = true;
            this._notificationStatusUpdated = true;

            if (!this._updatedProperties.includes(type)) {
                this._updatedProperties.push(type);
            }
        }
    }

    private _createTemporalNotification(duration: number): ITemporalNotification {
        const notification: ITemporalNotification = {
            start: dayjs().format(),
            visited: false,
            duration,
        };

        return notification;
    }
}
